import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
const DocumentArrowDownIcon = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <g id="solid/document-arrow-down"><path id="Icon" fillRule="evenodd" clipRule="evenodd" d="M5.39998 1.6001C4.40586 1.6001 3.59998 2.40589 3.59998 3.4V20.6001C3.59998 21.5942 4.40586 22.4001 5.39998 22.4001H18.6C19.5941 22.4001 20.4 21.5942 20.4 20.6001V8.35C20.4 7.87261 20.2103 7.40757 19.8728 7.07L14.9272 2.13C14.5896 1.79243 14.1318 1.6001 13.6544 1.6001H5.39998ZM11.1 10.5C11.1 10.0029 11.5029 9.6 12 9.6C12.497 9.6 12.9 10.0029 12.9 10.5V13.5546L14.031 12.2979C14.3635 11.9285 14.9326 11.8985 15.302 12.231C15.6715 12.5635 15.7015 13.1326 15.3689 13.5021L12.6689 16.5021C12.4983 16.6917 12.2551 16.8 12 16.8C11.7448 16.8 11.5017 16.6917 11.331 16.5021L8.63101 13.5021C8.2985 13.1326 8.32845 12.5635 8.69791 12.231C9.06737 11.8985 9.63643 11.9285 9.96894 12.2979L11.1 13.5546V10.5Z" fill="currentColor" /></g>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <svg width={24} height={24} viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>{t0}</svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default DocumentArrowDownIcon;